import { ImageColorFinderFlight } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateImageColorFinderFlightArgs,
    getDefaultImageColorFinderFlightCreateArgs,
    UpdateImageColorFinderFlightArgs,
} from "@nova/serializer/src/client/validators/flights/imageColorFinder"
import { selectImageColorFinderFlights } from "features/entity-caching/flights/selectors"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import { setFlightId } from "features/map/control/slice"
import { deleteUploadSet } from "plugins/ColorFinder/ImageColorFinder/ImageColorFinderSlice"
import { selectSingleLayer, setActiveLayerId } from "panels/content/side-panel/slice.new"

const {
    create: createImageColorFinderFlight,
    update: updateImageColorFinderFlight,
    delete: deleteImageColorFinderFlight,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    ImageColorFinderFlight, // entity type
    CreateImageColorFinderFlightArgs, // create args to send to server
    ["createdBy", "name"], // create args required by action
    UpdateImageColorFinderFlightArgs // update args
>("ImageColorFinderFlight")

export const addImageColorFinderFlightsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data } }, socket) => {
            const state = store.getState()
            const flights = selectImageColorFinderFlights(state)
            const name = data.name || `Image Colorfinder ${Object.values(flights).length + 1}`
            const args = { name, id: randomUUID() }
            const optimisticData = {
                ...args,
                ...getDefaultImageColorFinderFlightCreateArgs(state.project.data),
                ...data,
            }
            createImageColorFinderFlight(socket, { ...args, ...data })
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["imageColorFinderFlights"],
                })
            )

            store.dispatch(selectSingleLayer({ id: optimisticData.id }))
            store.dispatch(setFlightId(optimisticData.id))
            store.dispatch(setActiveLayerId({ id: optimisticData.id }))
        })
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateImageColorFinderFlight(socket, id, updates)
            store.dispatch(
                updateEntitySocket({ updates, path: ["imageColorFinderFlights", { id }] })
            )
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            const dispatch = store.dispatch
            dispatch(deleteUploadSet({ flightId: id }))
            deleteImageColorFinderFlight(socket, id)
            dispatch(deleteEntitySocket({ path: ["imageColorFinderFlights", { id }] }))
        })

export {
    createAction as createImageColorFinderFlight,
    updateAction as updateImageColorFinderFlight,
    deleteAction as deleteImageColorFinderFlight,
}
